import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "source", "share" ]
  static values = {
    htmlSource: {
      type: Boolean, default: false
    }
  }

  copy() {
    if (this.htmlSourceValue) {
      const type = "text/html"
      const blob = new Blob([this.sourceTarget.value], {type})
      const data = [new ClipboardItem({[type]: blob})]

      navigator.clipboard.write(data)
    } else {
      navigator.clipboard.writeText(this.sourceTarget.value)
    }

    let previousValue = this.shareTarget.innerText
    this.shareTarget.innerText = "Copié !"

    setTimeout(() => {
      this.shareTarget.innerText = previousValue
    }, 3000)
  }
}
